/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Highlight_Settings_Line_WordInputs */

const en_highlight_settings_line_word = /** @type {(inputs: Highlight_Settings_Line_WordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Line + word`)
};

const es_highlight_settings_line_word = /** @type {(inputs: Highlight_Settings_Line_WordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Línea + palabra`)
};

/**
* | output |
* | --- |
* | "Line + word" |
*
* @param {Highlight_Settings_Line_WordInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const highlight_settings_line_word = /** @type {((inputs?: Highlight_Settings_Line_WordInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Highlight_Settings_Line_WordInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_highlight_settings_line_word(inputs)
	return en_highlight_settings_line_word(inputs)
});